import { render, staticRenderFns } from "./shopOtoldTemplate.vue?vue&type=template&id=fef55658&"
import script from "./shopOtoldTemplate.vue?vue&type=script&lang=js&"
export * from "./shopOtoldTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports